exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js??ref--6-1!../../../../postcss-loader/src/index.js??ref--6-2!../global/variables.css"), "");

// module
exports.push([module.id, ".trapButton_a77 {\n  position: absolute;\n  left: -9999px;\n}\n", ""]);

// exports
exports.locals = {
	"trapButton": "trapButton_a77"
};